import { render } from "./documentosForm.vue?vue&type=template&id=377801d4"
import script from "./documentosForm.vue?vue&type=script&lang=js"
export * from "./documentosForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__